<template>
  <div>
    <div class="px-3 py-2" :style="`direction:${lang.dir}`">
      <b-sidebar
        aria-labelledby="sidebar-no-header-title"
        width="99vw"
        no-header
        id="view_crm"
        backdrop
        style="direction: ltr"
        right
        title="add order"
        shadow
      >
        <template #default="{ hide }">
          <div class="m-1 text-start" :style="`direction:` + $parent.lang.dir">
            <div
              style="
                width: 150px;
                margin-right: 10px;
                background: #000;
                color: #fff;
                border-radius: 5px;
              "
              class="btn-primary btn-sm text-center"
            >
              <span style="font-size: 0.8em"> {{ lang.view_crm }} </span>
            </div>
            <div
              @click="hide"
              id="vohclose"
              style="
                width: 100px;
                text-align: center;
                float: left;
                margin-left: 5px;
                margin-top: -25px;
                cursor: pointer;
              "
              class="btn-danger btn-sm"
            >
              <span>{{ $parent.lang.close }}</span>
            </div>
          </div>
          <v-divider></v-divider>
          <v-row style="direction: rtl" class="m-2">
            <v-col cols="12">
              <div
                class="backBlack"
                style="padding: 0px; width: 100%; text-align: center"
              >
                <!-- <b-button style="font-size:1.1rem;border:2px solid #fff !important;background:blue !important;width:120px;color:#fff;" class="mytab2 btn btn-sm btn-success m-2" v-b-toggle.add_gallery>{{lang.attachement}}</b-button> 
                                <b-button style="font-size:1.1rem;border:2px solid #fff !important;background:red !important;width:150px;color:#fff;" class="mytab2 btn btn-sm btn-success m-2" v-b-toggle.add_addpayment>{{lang.make_payment}}</b-button>  -->
                <b-button
                  class="mytab1 btn btn-sm btn-default m-2"
                  style="
                    border: 2px solid #fff !important;
                    width: 130px;
                    background: darkmagenta !important;
                    font-size: 1.1rem;
                    color: #fff;
                  "
                  @click="addNote()"
                  v-b-toggle.add_crmnote
                  >{{ lang.add_notes }}</b-button
                >
                
                
                <b-button
                  class="mytab1 btn btn-sm btn-default m-2"
                  style="
                    width: 130px;
                    background: darkslateblue !important;
                    color: #fff !important;
                    font-size: 1.1rem;
                    border: 2px solid #fff !important;
                  "
                  @click="addquotations()"
                  v-b-toggle.add_quotation
                  v-if="$store.state.group_id != 5"
                  >{{ lang.add_quotation }}
                </b-button>
                <b-button
                  class="mytab1 btn btn-sm btn-default m-2"
                  style="
                    border: 2px solid #fff !important;
                    width: 130px;
                    background: rgb(65, 57, 57) kgreen !important;
                    font-size: 1.1rem;
                    color: #fff;
                  "
                  v-b-toggle.publish_me
                  v-if="$store.state.group_id != 5"
                  @click="addLicense()"
                  >{{ lang.generate_license }}</b-button
                >
                <b-button
                  class="mytab1 btn btn-sm btn-default m-2"
                  style="
                    border: 2px solid #fff !important;
                    width: 130px;
                    background: lightgreen !important;
                    font-size: 1.1rem;
                    color: #000;
                  "
                  v-if="$store.state.group_id != 5"
                  @click="addinvoice()"
                  v-b-toggle.add_invoice
                  >{{ lang.create_invoice }}</b-button
                >
                <b-button
                  class="mytab1 btn btn-sm btn-default m-2"
                  style="
                    border: 2px solid #fff !important;
                    width: 130px;
                    background: red !important;
                    font-size: 1.1rem;
                    color: #fff;
                  "
                  @click="addTask()"
                  v-b-toggle.add_crmtask
                  >{{ lang.add_task }}</b-button
                >
                <b-button
                  class="mytab1 btn btn-sm btn-default m-2"
                  style="
                    border: 2px solid #fff !important;
                    width: 130px;
                    background: blue !important;
                    font-size: 1.1rem;
                    color: #fff;
                  "
                  @click="editCus()"
                  v-b-toggle.edit_CrmCase
                  >{{ lang.update }}</b-button
                >
                <img
                  :src="`../whatsappicon.png`"
                  style="
                    border: 2px solid #fff !important;
                    width: 120px;
                    margin-inline-start: 10px;
                    height: 38px;
                    border-radius: 5px;
                    cursor: pointer;
                  "
                />
              </div>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <v-simple-table>
                    <thead>
                      <tr v-if="customer.customer_type == 1">
                        <th colspan="4" class="backBlack" style="border: 2px solid #fff">
                          {{ lang.customer_info }}
                        </th>
                      </tr>
                      <tr v-if="customer.customer_type == 1">
                        <th class="backBlack" style="width: 100px">
                          {{ lang.city }}
                        </th>
                        <td>{{ details.city }}</td>
                        <th class="backBlack" style="width: 100px">{{ lang.industrial }}</th>
                        <td>{{ details[`industrial_`+lang.langname] }}</td>
                      </tr>
                      <!-- <tr v-if="customer.customer_type == 2">
                        <th colspan="6" class="backBlack" style="border: 2px solid #fff">
                          {{ lang.customer_info }}
                        </th>
                      </tr> -->
                      <tr v-if="customer.customer_type == 2">
                        <th class="backBlack" style="width: 100px">
                          {{ lang.city }}
                        </th>
                        <td colspan="2">{{ customer.city }}</td>
                        <th class="backBlack" style="width: 100px">{{ lang.industrial }}</th>
                        <td colspan="2">{{ customer.industrial }}</td>
                      </tr>
                      <!-- <tr v-if="customer.customer_type == 3">
                        <th colspan="6" class="backBlack" style="border: 2px solid #fff">
                          {{ lang.customer_info }}
                        </th>
                      </tr> -->
                      <tr v-if="customer.customer_type == 1">
                        <th class="backBlack" style="width: 100px">
                          {{ lang.full_name }}
                        </th>
                        <td>{{ customer.full_name }}</td>
                        <th class="backBlack" style="width: 100px">{{ lang.mobile }}</th>
                        <td style="width: 100px">{{ customer.mobile }}</td>
                      </tr>
                      <tr v-if="customer.customer_type == 2">
                        <th colspan="6" class="backBlack" style="border: 2px solid #fff">
                          {{ lang.customer_info }}
                        </th>
                      </tr>
                      <tr v-if="customer.customer_type == 2">
                        <th class="backBlack" style="width: 100px">
                          {{ lang.company_name }}
                        </th>
                        <td>{{ customer.company_name }}</td>
                        <th class="backBlack" style="width: 100px">{{ lang.mobile }}</th>
                        <td style="width: 100px">{{ customer.mobile }}</td>
                        <th class="backBlack" style="width: 100px">
                          {{ lang.crt_number }}
                        </th>
                        <td style="width: 100px">{{ customer.crt_number }}</td>
                      </tr>
                      <tr v-if="customer.customer_type == 2">
                        <th class="backBlack" style="width: 100px">
                          {{ lang.vat_number }}
                        </th>
                        <td>{{ customer.company_vatid }}</td>
                        <th class="backBlack" style="width: 100px">{{ lang.address }}</th>
                        <td style="width: 100px" colspan="3">{{ customer.address }}</td>
                      </tr>
                    </thead>
                  </v-simple-table>
                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th class="backBlack" colspan="6">{{ lang.details }}</th>
                      </tr>
                      <tr>
                        <th class="backBlack" style="width: 100px">{{ lang.status }}</th>
                        <td
                          :style="`width:120px;background:${details.status_bg} !important;color:${details.status_co} !important;`"
                        >
                          {{ details[`status_` + lang.langname] }}
                        </td>
                        <th class="backBlack" style="width: 100px">
                          {{ lang.last_action }}
                        </th>
                        <td
                          :style="`background:${details.last_action_bg} !important;color:${details.last_action_co} !important;`"
                        >
                          {{ details[`last_action_` + lang.langname] }}
                        </td>
                        <th class="backBlack" style="width: 100px">
                          {{ lang.last_action_date }}
                        </th>
                        <td style="width: 100px">{{ details.last_action_date }}</td>
                      </tr>
                      <tr>
                        <th class="backBlack" style="width: 100px">{{ lang.agent }}</th>
                        <td style="width: 120px">{{ details._agent }}</td>
                        <th class="backBlack" style="width: 100px">
                          {{ lang.next_action }}
                        </th>
                        <td
                          :style="`background:${details.next_action_bg} !important;color:${details.next_action_co} !important;`"
                        >
                          {{ details[`next_action_` + lang.langname] }}
                        </td>
                        <th class="backBlack" style="width: 100px">
                          {{ lang.next_action_date }}
                        </th>
                        <td style="width: 100px">{{ details.next_action_date }}</td>
                      </tr>
                      <tr>
                        <th class="backBlack" style="width: 100px">{{ lang.copies }}</th>
                        <td style="width: 120px">{{ details.copies }}</td>
                        <th class="backBlack" style="width: 100px">{{ lang.amount }}</th>
                        <td style="width: 120px">{{ details.amount }}</td>
                        <th class="backBlack" style="width: 100px">
                          {{ lang.include_computers }}
                        </th>
                        <td style="width: 120px">{{ doComputer(details.computer) }}</td>
                      </tr>
                      <tr>
                        <th class="backBlack" style="width: 100px">
                          {{ lang.work_type }}
                        </th>
                        <td
                          :style="`width:120px;background:${details.work_type_bg} !important;color:${details.work_type_co} !important;`"
                        >
                          {{ details[`work_type_` + lang.langname] }}
                        </td>
                        <!-- <th class="backBlack" style="width:100px;">{{ lang.license_url }}</th>
                                                <td style="width:120px;" colspan="4">{{ details.license_url }}</td> -->
                      </tr>
                    </thead>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th class="backBlack text-center" colspan="8">
                          {{ lang.invoices }}
                        </th>
                      </tr>
                      <tr>
                        <th class="backBlack text-center">{{ lang.inv_date }}</th>
                        <th class="backBlack text-center">{{ lang.invoiceno }}</th>
                        <th class="backBlack text-center">{{ lang.total }}</th>
                        <th class="backBlack text-center">{{ lang.vat }}</th>
                        <th class="backBlack text-center">{{ lang.ftotal }}</th>
                        <th class="backBlack text-center">{{ lang.paid }}</th>
                        <th class="backBlack text-center">{{ lang.remain }}</th>
                        <th class="backBlack text-center">{{ lang.action }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in invRows" :key="index">
                        <td class="text-center">{{ item.inv_date }}</td>
                        <td class="text-center">{{ item.invoice_number }}</td>
                        <td class="text-center">{{ item.total }}</td>
                        <td class="text-center">{{ item.vat }}</td>
                        <td class="text-center">{{ item.ftotal }}</td>
                        <td class="text-center">{{ item.paid }}</td>
                        <td class="text-center">{{ item.remain }}</td>
                        <td
                          style="
                            margin-left: 5px;
                            width: 80px;
                            background: blue;
                            border-bottom: 2px solid #fff !important;
                            border-top: 2px solid #fff !important;
                          "
                        >
                          <div class="viewBTN" @click="printPDF(item.id, 1)">
                            {{ lang.print }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th class="backBlack text-center" colspan="7">
                          {{ lang.quotations }}
                        </th>
                      </tr>
                      <tr>
                        <th class="backBlack text-center">{{ lang.quot_date }}</th>
                        <th class="backBlack text-center">{{ lang.quotnumber }}</th>
                        <th class="backBlack text-center">{{ lang.total }}</th>
                        <th class="backBlack text-center">{{ lang.vat }}</th>
                        <th class="backBlack text-center">{{ lang.ftotal }}</th>
                        <th class="backBlack text-center">{{ lang.status }}</th>
                        <th class="backBlack text-center">{{ lang.action }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in quotRows" :key="index">
                        <td class="text-center">{{ item.quot_date }}</td>
                        <td class="text-center">{{ item.quot_number }}</td>
                        <td class="text-center">{{ item.total }}</td>
                        <td class="text-center">{{ item.vat }}</td>
                        <td class="text-center">{{ item.ftotal }}</td>
                        <td class="text-center">{{ item[`status_` + lang.langname] }}</td>
                        <td
                          style="
                            margin-left: 5px;
                            width: 80px;
                            background: blue;
                            border-bottom: 2px solid #fff !important;
                            border-top: 2px solid #fff !important;
                          "
                        >
                          <div class="viewBTN" @click="printPDF(item.id, 3)">
                            {{ lang.print }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th class="backBlack text-center" colspan="5">
                          {{ lang.payments }}
                        </th>
                      </tr>
                      <tr>
                        <th class="backBlack text-center">{{ lang.date }}</th>
                        <th class="backBlack text-center">{{ lang.voutcher_no }}</th>
                        <th class="backBlack text-center">{{ lang.amount }}</th>
                        <th class="backBlack text-center">{{ lang.payment_type }}</th>
                        <th class="backBlack text-center">{{ lang.action }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in payRows" :key="index">
                        <td class="text-center">{{ item.receipt_date }}</td>
                        <td class="text-center">{{ item.voutcherid }}</td>
                        <td class="text-center">{{ item.ftotal }}</td>
                        <td class="text-center">
                          {{ item[`paytype_` + lang.langname] }}
                        </td>
                        <td
                          style="
                            margin-left: 5px;
                            width: 80px;
                            background: blue;
                            border-bottom: 2px solid #fff !important;
                            border-top: 2px solid #fff !important;
                          "
                        >
                          <div class="viewBTN" @click="printPDF(item.voutcherid, 2)">
                            {{ lang.print }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th class="backBlack text-center" colspan="4">
                          {{ lang.notes }}
                        </th>
                      </tr>
                      <tr>
                        <th class="backBlack text-center">{{ lang.notes }}</th>
                        <th class="backBlack text-center" style="width: 100px">
                          {{ lang.note_type }}
                        </th>
                        <th class="backBlack text-center" style="width: 100px">
                          {{ lang.added_by }}
                        </th>
                        <th class="backBlack text-center" style="width: 100px">
                          {{ lang.added_date }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in notesRows" :key="index">
                        <td class="text-center">{{ item.note_text }}</td>
                        <td class="text-center">
                          {{ item[`note_type_` + lang.langname] }}
                        </td>
                        <td class="text-center">{{ item.added_by }}</td>
                        <td class="text-center">{{ item.added_date }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th class="backBlack text-center" colspan="8">
                          {{ lang.tasks }}
                        </th>
                      </tr>
                      <tr>
                        <th class="backBlack text-center" style="width: 100px">
                          {{ lang.date }}
                        </th>
                        <th class="backBlack text-center">{{ lang.task_description }}</th>
                        <th class="backBlack text-center" style="width: 100px">
                          {{ lang.added_by }}
                        </th>
                        <th class="backBlack text-center" style="width: 100px">
                          {{ lang.task_response }}
                        </th>
                        <th class="backBlack text-center" style="width: 100px">
                          {{ lang.last_update_date }}
                        </th>
                        <th class="backBlack text-center" style="width: 100px">
                          {{ lang.last_update_date }}
                        </th>
                        <th class="backBlack text-center" style="width: 100px">
                          {{ lang.status }}
                        </th>
                        <th class="backBlack text-center" style="width: 100px">
                          {{ lang.action }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in tasksRows" :key="index">
                        <td class="text-center">{{ item.task_date }}</td>
                        <td class="text-center">{{ item.task_text }}</td>
                        <td class="text-center">{{ item.created_by }}</td>
                        <td class="text-center">{{ item.task_response }}</td>
                        <td class="text-center">{{ item.closed_date }}</td>
                        <td class="text-center">{{ item.closed_by }}</td>
                        <td
                          class="text-center"
                          :style="`background:${item.status_bg} !important;color:${item.status_co} !important`"
                        >
                          {{ item[`status_` + lang.langname] }}
                        </td>
                        <td
                          style="
                            margin-left: 5px;
                            width: 80px;
                            background: blue;
                            border-bottom: 2px solid #fff !important;
                            border-top: 2px solid #fff !important;
                          "
                          @click="editTask(item)"
                          v-b-toggle.update_crmtask
                        >
                          <div class="viewBTN" style="cursor: pointer">
                            {{ lang.view }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </b-sidebar>
    </div>
    <AddNewCrmNotes ref="addnotes" />
    <AddNewCrmTask ref="addtask" />
    <addInvoice ref="addInvoice" />
    <AddQuotation ref="AddQuotation" />
    <AddNewCrmLicense ref="AddNewCrmLicense" />
    <EditCrmCustomer ref="EditCrmCustomer" />
    <UpdateNewCrmTask ref="UpdateNewCrmTask" />
  </div>
</template>

<script>
import axios from "axios";
import AddNewCrmNotes from "@/components/AddNewCrmNotes.vue";
import addInvoice from "@/components/addInvoice.vue";
import AddQuotation from "@/components/addQuotation.vue";
import AddNewCrmTask from "@/components/AddNewCrmTask.vue";
import UpdateNewCrmTask from "@/components/UpdateNewCrmTask.vue";
import AddNewCrmLicense from "@/components/AddNewCrmLicense.vue";
import EditCrmCustomer from "@/components/crm/EditCrmCustomer.vue";
export default {
  components: {
    AddNewCrmNotes,
    addInvoice,
    AddQuotation,
    AddNewCrmTask,
    AddNewCrmLicense,
    EditCrmCustomer,
    UpdateNewCrmTask,
  },
  data() {
    return {
      id: 0,
      customer: {},
      details: {
        // status: 1,
        // last_action: 1,
        // last_action_date: '2023-07-01',
        // agent: 'محمد علي',
        // next_action: 2,
        // next_action_date: '2023-07-08',
        // license_url: 'demo.e-carstech.com',
        // work_type: 1,
      },
      staticOption: [],
      invRows: [],
      quotRows: [],
      payRows: [],
      notesRows: [],
      tasksRows: [],
    };
  },
  computed: {
    lang: function () {
      if (this.$cookies.get(this.$store.state.LangCooki) != null) {
        if (this.$cookies.get(this.$store.state.LangCooki) == "en") {
          return this.$store.state.lang.en;
        } else {
          return this.$store.state.lang.ar;
        }
      } else if (this.$store.state.deflang == "en") {
        return this.$store.state.lang.en;
      } else {
        return this.$store.state.lang.ar;
      }
    },
    is_mobile: function(){
        return false;
    },
    Statics: function () {
      let t = {
        crmActions: {},
        crmStatus: {},
        crmType: {},
      };
      for (let i = 0; i < this.staticOption.length; i++) {
        if (this.staticOption[i].option_phrase == "crmActions") {
          t.crmActions[this.staticOption[i].value] = {
            id: this.staticOption[i].value,
            name_ar: this.staticOption[i].name_ar,
            name_en: this.staticOption[i].name_en,
            bgColor: this.staticOption[i].bgColor,
            color: this.staticOption[i].color,
          };
        } else if (this.staticOption[i].option_phrase == "crmStatus") {
          t.crmStatus[this.staticOption[i].value] = {
            id: this.staticOption[i].value,
            name_ar: this.staticOption[i].name_ar,
            name_en: this.staticOption[i].name_en,
            bgColor: this.staticOption[i].bgColor,
            color: this.staticOption[i].color,
          };
        } else if (this.staticOption[i].option_phrase == "crmType") {
          t.crmType[this.staticOption[i].value] = {
            id: this.staticOption[i].value,
            name_ar: this.staticOption[i].name_ar,
            name_en: this.staticOption[i].name_en,
            bgColor: this.staticOption[i].bgColor,
            color: this.staticOption[i].color,
          };
        }
      }
      return t;
    },
  },
  methods: {
    addLicense(){
      this.$refs.AddNewCrmLicense.orderid = this.id;
    },
    editTask(item) {
        console.log("hello ",item);
      this.$refs.UpdateNewCrmTask.crm_id = item.id;
      this.$refs.UpdateNewCrmTask.task_response = item.agent;
      this.$refs.UpdateNewCrmTask.status = item.status;
      this.$refs.UpdateNewCrmTask.notes = '';
      this.$refs.UpdateNewCrmTask.getTaskDet();
    },
    editCus() {
      this.$refs.EditCrmCustomer.crm_id = this.id;
      this.$refs.EditCrmCustomer.work_type = this.details.work_type;
      this.$refs.EditCrmCustomer.next_action = this.details.next_action;
      this.$refs.EditCrmCustomer.status = this.details.status;
      this.$refs.EditCrmCustomer.agent = this.details.agent;
      this.$refs.EditCrmCustomer.copies = this.details.copies;
      this.$refs.EditCrmCustomer.amount = this.details.amount;
      this.$refs.EditCrmCustomer.computer = this.details.computer;
    },
    addinvoice() {
      this.$refs.addInvoice.crmid = this.id;
      this.$refs.addInvoice.cctype = this.customer.customer_type;
      this.$refs.addInvoice.changeCusType(parseFloat(this.customer.customer_type) - 1);
      this.$refs.addInvoice.customer.mobile = this.customer.mobile;
      this.$refs.addInvoice.getName(parseFloat(this.customer.customer_type) - 1);
    },
    addquotations() {
      this.$refs.AddQuotation.crmid = this.id;
      this.$refs.AddQuotation.cctype = this.customer.customer_type;
      this.$refs.AddQuotation.changeCusType(parseFloat(this.customer.customer_type) - 1);
      this.$refs.AddQuotation.customer.mobile = this.customer.mobile;
      this.$refs.AddQuotation.getName();
    },
    addNote() {
      this.$refs.addnotes.crm_id = this.id;
    },
    addTask() {
      this.$refs.addtask.crm_id = this.id;
    },
    printPDF(id, t) {
      // if(navigator.share){
      //     navigator.share({
      //         files: [new File([this.readFile('../api/print.php?invid='+id)],'file.pdf',{type: Blob.type})],
      //         title: '',
      //         text: '',
      //     })
      // }else{
      let pdfFrame = document.body.appendChild(document.createElement("iframe"));
      pdfFrame.style.display = "none";
      pdfFrame.onload = () => void pdfFrame.contentWindow.print();
      if (t == 1) pdfFrame.src = "../api/print.php?invid=" + id;
      if (t == 2) pdfFrame.src = "../api/print.php?recpid=" + id;
      if (t == 3) pdfFrame.src = "../api/print.php?quotid=" + id;
      // }
    },
    getCRMData(id) {
      if (id == 0) {
        return false;
      }
      let post = new FormData();
      let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
      const path = this.$router.currentRoute.path;
      post.append("type", "getCRMData");
      post.append("auth", cook);
      post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
      post.append("data[id]", id);
      axios.post(this.$SAMCOTEC.r_path, post).then((response) => {
        if (response && response.data && response.data.results) {
          this.id = response.data.results.details.id;
          this.details = response.data.results.details;
          this.customer = response.data.results.customer;
          this.invRows = response.data.results.invRows;
          this.quotRows = response.data.results.quotRows;
          this.payRows = response.data.results.payRows;
          this.notesRows = response.data.results.notesRows;
          this.tasksRows = response.data.results.tasksRows;
        }
      });
    },
    doComputer(id) {
      if (id == 0) {
        return this.lang.no_devices;
      } else if (id == 1) {
        return this.lang.yes_19;
      } else if (id == 2) {
        return this.lang.yes_24;
      }
    },
    async getStaticOp() {
      let post = new FormData();
      let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
      const path = this.$router.currentRoute.path;
      post.append("type", "getStaticOptions");
      post.append("auth", cook);
      post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
      post.append("data[test]", "1");
      const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post);
      if (response && response.data) {
        this.staticOption = response.data.results.data;
      }
    },
  },
  created() {
    this.getStaticOp();
  },
};
</script>
